module.exports = __webpack_public_path__ + "media/images/es_419/efficacy-segment-2bbf8ab44b4ed6a28796ae87ebf33148.jpg";